import { FC } from 'react';

import { RichTextContent } from '@telialt/common-rich-text-content/src/RichTextContent';

import { BlogSectionType } from '../../../models/Content';
import { ContentWrapper, NoteTitle, StyledSectionNote } from './SectionNote.styles';
import { transformSectionNote } from './transformers';

type Props = {
    contentItem: BlogSectionType;
    $highlight?: boolean;
};

export const SectionNote: FC<Props> = ({ contentItem, $highlight }) => {
    const { title, text } = transformSectionNote(contentItem);

    return (
        <StyledSectionNote $highlight={$highlight}>
            <ContentWrapper>
                <NoteTitle>{title}</NoteTitle>
                <RichTextContent richText={text} />
            </ContentWrapper>
        </StyledSectionNote>
    );
};
